// extracted by mini-css-extract-plugin
module.exports = {"input":"aCHJgt","label":"c1xprBV","radio":"Gn3UH1"};